var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-len */
import React from "react";
import id from "@irati/utils/id";
import BaseSvgIcon from "./Base";
var Visibility = function (props) {
    var titleId = id("title", props);
    var title = props.title, rest = __rest(props, ["title"]);
    return (React.createElement(BaseSvgIcon, __assign({}, rest, { "aria-labelledby": titleId }),
        React.createElement("title", { id: titleId }, title),
        React.createElement("g", { fill: "none", fillRule: "evenodd", strokeWidth: "1" },
            React.createElement("rect", { width: "18", height: "18", rx: "1" }),
            React.createElement("g", { transform: "translate(3 6)", stroke: "#3D3D36", strokeLinecap: "round" },
                React.createElement("path", { transform: "translate(6.0091 2.3252) rotate(-90) translate(-6.0091 -2.3252)", d: "m4.3506 8.0814c1.9837-1.155 3.317-3.3045 3.317-5.7653 0-2.448-1.3194-4.5877-3.2858-5.747" }),
                React.createElement("path", { transform: "translate(6.0069 5.6978) scale(1 -1) rotate(-90) translate(-6.0069 -5.6978)", d: "m4.3713 11.429c1.9583-1.1613 3.2711-3.2965 3.2711-5.7384 0-2.4323-1.3025-4.5603-3.2481-5.7246" })),
            React.createElement("path", { d: "m9 11.5c0.82843 0 1.5-0.67157 1.5-1.5 0-0.82843-0.67157-1.5-1.5-1.5s-1.5 0.67157-1.5 1.5c0 0.82843 0.67157 1.5 1.5 1.5z", stroke: "#3D3D36", strokeLinecap: "round" }))));
};
Visibility.defaultProps = {
    id: "visibility-icon",
    title: "Visibility"
};
export default Visibility;
